import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {MaterialModule} from '../../material/material.module';
import {RightbarComponent} from './rightbar/rightbar.component';
import {CompareComponent} from './rightbar/compare/compare.component';
import {BasicFilterComponent} from './filters/basic/basic-filter.component';

@NgModule({
  declarations: [
    RightbarComponent,
    CompareComponent,
    BasicFilterComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxSliderModule,
    MaterialModule,
  ],
  exports: [
    RightbarComponent,
    CompareComponent,
    BasicFilterComponent,
  ],
})
export class ListingBrowseUiModule {}
